export default __webpack_public_path__ + "static/media/loc-material-1.4becbb3f.webp";